// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Custom
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';

// Component
import { DashboardComponent } from '../pages/dashboard/dashboard.component';
import { NavbarComponent } from '../pages/navbar/navbar.component';
import { SidebarComponent } from '../pages/sidebar/sidebar.component';
import { SummaryComponent } from '../pages/summary/summary.component';
import { CreateUserComponent } from '../pages/create-user/create-user.component';
import { UsersComponent } from '../pages/users/users.component';
import { PagebarComponent } from '../shared/pagebar/pagebar.component';
import { UserShowComponent } from '../shared/modals/base-modal/user-show/user-show.component';
import { UserEditComponent } from '../shared/modals/base-modal/user-edit/user-edit.component';
import { UserDeleteComponent } from '../shared/modals/base-modal/user-delete/user-delete.component';
import { UserDetailsComponent } from '../shared/modals/base-modal/user-details/user-details.component';
import { AdminUsersComponent } from '../pages/admin-users/admin-users.component';
import { TransactionsComponent } from '../pages/transactions/transactions.component';
import { TransactionShowComponent } from '../shared/modals/base-modal/transaction-show/transaction-show.component';
import { VouchersComponent } from '../pages/vouchers/vouchers.component';
import { VoucherShowComponent } from '../shared/modals/base-modal/voucher-show/voucher-show.component';
import { BaseModalComponent } from '../shared/modals/base-modal/base-modal.component';
import { ControlPanelComponent } from '../shared/modals/base-modal/control-panel/control-panel.component';
import { GraphComponent } from '../shared/graph/graph.component';
import { GraphUsersComponent } from '../shared/graph-users/graph-users.component'
import { RedeemComponent } from '../pages/referrals/referrals/redeem.component';
import { RedeemShowComponent } from '../shared/modals/base-modal/redeem-show/redeem-show.component';
import { ConfirmRedeemComponent } from '../shared/modals/base-modal/confirm-redeem/confirm-redeem.component';
import { CountriesComponent } from '../shared/modals/countries/countries.component';
import { VoucherEditComponent } from '../shared/modals/voucher-edit/voucher-edit.component';
import { LicenseComponent } from '../pages/licenses/license.component';
import { LicenseCreateComponent } from '../shared/modals/license-create/license-create.component';
import { LicenseDeleteComponent } from '../shared/modals/license-delete/license-delete.component';
import { LicenseShowComponent } from '../shared/modals/base-modal/license-show/license-show.component';
import { LicenseEditComponent } from '../shared/modals/license-edit/license-edit.component';
import { ActiveUsersComponent } from '../pages/online-device/online-device.component'; 
import { ManagerShowComponent } from '../shared/modals/base-modal/manager-show/manager-show.component'
import { ManagerEditComponent } from '../shared/modals/base-modal/manager-edit/manager-edit.component'
import { ManagerDeleteComponent } from  '../shared/modals/base-modal/manager-delete/manager-delete.component'
import { ManagerCreateComponent } from '../shared/modals/base-modal/manager-create/manager-create.component'
import { ManagerUsersComponent } from '../pages/manager-users/manager-users.component'





// Route Guards
import { CheckLoginGuard } from '../services/route-guards/check-login.service';
import { VoucherDeleteComponent } from '../shared/modals/voucher-delete/voucher-delete.component';
import { VoucherCreateComponent } from '../shared/modals/voucher-create/voucher-create.component';
import { VoucherListComponent } from '../shared/modals/voucher-list/voucher-list.component';
import { VoucherRedeemedComponent } from '../shared/voucher-redeemed/voucher-redeemed.component';
import { MAX_LENGTH_VALIDATOR } from '@angular/forms/src/directives/validators';

// Dashboard Routes
const routes: Routes = [{
  path: 'dashboard', component: DashboardComponent, canActivate: [CheckLoginGuard], children: [
    {
      path: 'summary', component: SummaryComponent
    },
    {
      path: 'create-user', component: CreateUserComponent
    },
    {
      path: 'users', component: UsersComponent
    },
    {
      path: 'admin-users', component: AdminUsersComponent
    },
    {
      path :'manager-users',component: ManagerUsersComponent
    },
    {
      path:'active-users',component: ActiveUsersComponent
    },
    {
      path: 'transactions', component: TransactionsComponent
    },
    {
      path: 'vouchers', component: VouchersComponent
    },
    {
      path: 'redeem', component: RedeemComponent
    },
    {
      path:'licenses',component:LicenseComponent
    },
    {
      path: '', redirectTo: 'summary', pathMatch: 'full'
    },
    {
      path: '**', component: DashboardComponent
    }
  ]
}];

@NgModule({
  declarations: [
    NavbarComponent,
    SidebarComponent,
    SummaryComponent,
    CreateUserComponent,
    UsersComponent,
    PagebarComponent,
    UserShowComponent,
    UserEditComponent,
    UserDeleteComponent,
    UserDetailsComponent,
    AdminUsersComponent,
    TransactionsComponent,
    TransactionShowComponent,
    VouchersComponent,
    VoucherShowComponent,
    BaseModalComponent,
    ControlPanelComponent,
    GraphComponent,
    GraphUsersComponent,
    RedeemComponent,
    RedeemShowComponent,
    ConfirmRedeemComponent,
    CountriesComponent,
    VoucherEditComponent,
    VoucherDeleteComponent,
    VoucherCreateComponent,
    VoucherListComponent,
    LicenseComponent,
    LicenseCreateComponent,
    LicenseShowComponent,
    LicenseEditComponent,
    LicenseDeleteComponent,
    ActiveUsersComponent,
    ManagerShowComponent,
    ManagerUsersComponent,
    ManagerEditComponent,
    ManagerDeleteComponent,
    ManagerCreateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule
  ],
  entryComponents: [BaseModalComponent, UserDeleteComponent, ControlPanelComponent, ConfirmRedeemComponent, CountriesComponent,
    VoucherDeleteComponent, VoucherCreateComponent, VoucherListComponent, VoucherRedeemedComponent,LicenseComponent,LicenseCreateComponent,LicenseDeleteComponent,ManagerDeleteComponent,ManagerCreateComponent],
  providers: [NgbActiveModal],
  exports: [NavbarComponent, SidebarComponent, RouterModule]
})
export class DashboardModule { }
